<form [formGroup]="skillsForm">
  <div class="step-container">
    <ng-template #labelSix>{{ getTranslation('skills.title') }}</ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('skills.title') : getTranslation('skills.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>

    <div *ngIf="isJsonShow">
      {{ skillsForm.value | json }}
    </div>

    <div class="row gx-2 mb-2">
      <div class="form-group col-12">
        <label class="form-label small text-muted mb-1">{{ getTranslation('skills.instructions') }}</label>
      </div>
    </div>

    <div formArrayName="Categories">
      <div *ngFor="let category of categories.controls; let i = index" [formGroupName]="i" class="category-section mb-2 border rounded bg-white shadow-sm">
        <!-- Category Header & Toggle -->
        <div class="category-header p-2" (click)="toggleCategory(i)" style="cursor: pointer;">
          <div class="row align-items-center">
            <div class="col-md-4 d-flex align-items-center">
              <i class="fas mr-2" [ngClass]="isCategoryExpanded(i) ? 'fa-chevron-down' : 'fa-chevron-right'" style="font-size: 0.7rem; color: #6c757d;"></i>
              <label class="form-label mb-0 small font-weight-bold text-primary">{{ category.get('Name')?.value }}</label>
            </div>
            <div class="col-md-4" *ngIf="category.get('HasYesNoToggle')?.value" (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center">
                <div class="form-check form-check-inline mr-2">
                  <input type="radio" [id]="'isSelectedYes' + i" [value]="true" formControlName="IsSelected" class="form-check-input" (change)="onCategoryToggle(i, true)" />
                  <label [for]="'isSelectedYes' + i" class="form-check-label small">{{ getTranslation('common.yes') }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input type="radio" [id]="'isSelectedNo' + i" [value]="false" formControlName="IsSelected" class="form-check-input" (change)="onCategoryToggle(i, false)" />
                  <label [for]="'isSelectedNo' + i" class="form-check-label small">{{ getTranslation('common.no') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Skill Items within Category -->
        <!-- Visible if Category is GENERAL or KEY_ABILITIES or IsSelected is true AND expanded -->
        <div *ngIf="(category.get('Code')?.value === 'GENERAL' || category.get('Code')?.value === 'KEY_ABILITIES' || category.get('IsSelected')?.value) && isCategoryExpanded(i)"
             class="skill-items-container border-top">
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover align-middle mb-0 compact-table">
              <thead class="bg-light">
                <tr class="small text-muted text-center">
                  <th style="width: 30%;">{{ getTranslation('skills.table.skillName') }}</th>
                  <th style="width: 40%;">{{ getTranslation('skills.table.proficiency') }}</th>
                  <th style="width: 30%;">{{ getTranslation('skills.table.specify') }}</th>
                </tr>
              </thead>
              <tbody formArrayName="SkillItems">
                <tr *ngFor="let item of getSkillItems(i).controls; let j = index" [formGroupName]="j" class="compact-row">
                  <td class="small fw-medium">{{ item.get('Name')?.value }}</td>
                  <td>
                    <div class="d-flex justify-content-center">
                      <!-- Hidden input to maintain form control binding -->
                      <input
                        type="hidden"
                        formControlName="UserAnseredSkillRatingId"
                      />
                      <button
                        type="button"
                        class="skill-proficiency-btn"
                        [disabled]="!isEditable"
                        (click)="cycleProficiencyLevel(i, j)"
                      >
                        <span class="skill-rating-bars">
                          <span
                            *ngFor="let bar of getTotalBlocks(); let k = index"
                            class="skill-rating-bar"
                            [class.filled]="k < getBlocksForRating(item.get('UserAnseredSkillRatingId')?.value || 0).length"
                          ></span>
                        </span>
                        <span class="skill-rating-text">
                          {{ getTranslation(getCurrentRating(item.get('UserAnseredSkillRatingId')?.value || 0).labelKey) }}
                        </span>
                      </button>
                    </div>
                  </td>
                  <td>
                    <div *ngIf="item.get('HasSpecifyText')?.value">
                      <input type="text" 
                             formControlName="UserAnseredSpecifyText" 
                             class="form-control form-control-sm compact-input" 
                             [placeholder]="item.get('SpecifyLabel')?.value || getTranslation('skills.placeholder.otherSkills')" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="skillsForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->

</form>
